// extracted by mini-css-extract-plugin
export default {"swiper":"Carousel_swiper__qz3B7","slide":"Carousel_slide__GKmsi","navigation":"Carousel_navigation__bBBBB","wrapper":"Carousel_wrapper__Jp5M8"};